export default "__VITE_PUBLIC_ASSET__32ad5533__"